import { useState, useEffect } from 'react';
import { Table, Row, Col, Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { getItem } from '../../services/Items/Inventory';
import { useNavigate } from 'react-router-dom';
import QRGenerator from '../Common/QRGenerator';

function ItemDetailsModal({ show, handleClose, id, handleOpenModalLogs, token }) {
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const handleEdit = () => {
        navigate(`/editItem/${id}`);
    }
    useEffect(() => {
        getItem(id).then(item => {
            console.log(item)
            setData(item);
        })
    }, [id])

    const isValidValue = (value) => {
        return value !== null && value !== undefined && value !== '';
    };

    const isValidNumber = (value) => {
        if (value === null || value === undefined || value === '') {
            return false;
        }
        const num = parseFloat(value);
        return !isNaN(num);
    };

    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === '' || isNaN(value)) {
            return '-';
        }
        
        const number = parseFloat(value);
        
        if (isNaN(number)) {
            return '-';
        }
        
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(number);
    };

    const calculateInventoryValue = (unitPrice, quantity) => {
        const price = parseFloat(unitPrice);
        const qty = parseFloat(quantity);
        
        // Si ambos son nulos o inválidos
        if (isNaN(price) && isNaN(qty)) {
            return '-';
        }
        
        // Si quantity es nulo pero unitPrice no
        if (isNaN(qty) && !isNaN(price)) {
            return formatCurrency(price);
        }
        
        // Si unitPrice es nulo pero quantity no
        if (isNaN(price) && !isNaN(qty)) {
            return '-';
        }
        
        // Si ambos tienen valor, multiplicar
        if (!isNaN(price) && !isNaN(qty)) {
            return formatCurrency(price * qty);
        }
        
        return '-';
    };

    return (
        <Modal size="lg" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Detalles</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xl={12} >
                        <Table bordered hover responsive>
                            <thead>
                                <tr className='table-dark'>
                                    <th className='text-center'>
                                        Campo
                                    </th>
                                    <th className='text-center'>
                                        Valor
                                    </th>
                                </tr>
                            </thead>
                            {
                                data ? (
                                    <tbody>
                                        {isValidValue(data.name) && (
                                        <tr >
                                            <td className='bg-light  text-end' >
                                                Nombre:
                                            </td>
                                            <td className='text-center'>
                                                {data.name}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.description) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Descripción:
                                            </td>
                                            <td className='text-center'>
                                                {data.description}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.additionalNotes) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Notas adicionales:
                                            </td>
                                            <td className='text-center'>
                                                {data.additionalNotes}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.acquisitionDateHumanFormatted) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Fecha de adquisición:
                                            </td>
                                            <td className='text-center'>
                                                {data.acquisitionDateHumanFormatted}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidNumber(data.quantity) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Cantidad en inventario:
                                            </td>
                                            <td className='text-center'>
                                                {data.quantity}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidNumber(data.unitPrice) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Precio unitario:
                                            </td>
                                            <td className='text-center'>
                                                {formatCurrency(data.unitPrice)}
                                            </td>
                                        </tr>
                                        )}
                                        {(isValidNumber(data.unitPrice) || isValidNumber(data.quantity)) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Valor en inventario:
                                            </td>
                                            <td className='text-center'>
                                                {calculateInventoryValue(data.unitPrice, data.quantity)}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.categoryName) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Categoría:
                                            </td>
                                            <td className='text-center'>
                                                {data.categoryName}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.subcategoryName) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Subategoría:
                                            </td>
                                            <td className='text-center'>
                                                {data.subcategoryName}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.locationName) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Ubicación:
                                            </td>
                                            <td className='text-center'>
                                                {data.locationName}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.statusName) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Estatus:
                                            </td>
                                            <td className='text-center'>
                                                {data.statusName}
                                            </td>
                                        </tr>
                                        )}
                                        {/* Aqui va el asignado a  */}
                                        {isValidValue(data.assignedToUser) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Asignado a:
                                            </td>
                                            <td className='text-center'>
                                                {data.assignedToUser}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.barcode) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Código de barras:
                                            </td>
                                            <td className='text-center'>
                                                {data.barcode}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.serialNumber) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Número de serie
                                            </td>
                                            <td className='text-center'>
                                                {data.serialNumber}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.partNumber) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Número de parte
                                            </td>
                                            <td className='text-center'>
                                                {data.partNumber}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.tag) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Etiqueta de identificación:
                                            </td>
                                            <td className='text-center'>
                                                {data.tag}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.brand) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Marca:
                                            </td>
                                            <td className='text-center'>
                                                {data.brand}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.model) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Modelo:
                                            </td>
                                            <td className='text-center'>
                                                {data.model}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidValue(data.dimensions) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Dimensiones:
                                            </td>
                                            <td className='text-center'>
                                                {data.dimensions}
                                            </td>
                                        </tr>
                                        )}
                                        {isValidNumber(data.weight) && (
                                        <tr >
                                            <td className='bg-light text-end'>
                                                Peso:
                                            </td>
                                            <td className='text-center'>
                                                {data.weight} {data.unitOfWeightMeasurement ? data.unitOfWeightMeasurement : null}
                                            </td>
                                        </tr>
                                        )}
                                    </tbody>
                                ) :
                                    (
                                        <tbody>
                                            <tr >
                                                <td className='text-center'>

                                                </td>
                                                <td className='text-center'>

                                                </td>
                                            </tr>
                                        </tbody>
                                    )
                            }

                        </Table>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                {token && (
                    <>
                        <Button 
                            size='sm' 
                            variant='success'
                            onClick={() => window.open(`/viewItem/${token}`, '_blank')}
                        >
                            <i className="bi bi-box-arrow-up-right"></i> Ver link público
                        </Button>
                        <QRGenerator
                            url={`${process.env.REACT_APP_BASE_URL}/viewItem/${token}`}
                            filename={`qr-${data.name || 'item'}-${id}`}
                        />
                    </>
                )}
                <Button size='sm' variant='outline-info' onClick={() => handleOpenModalLogs(id)}>Historial de cambios</Button>
                <Button size='sm' variant='outline-warning' onClick={handleEdit}>Editar</Button>
                <Button size='sm' variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ItemDetailsModal;